/**
 * Режим указания ячеек при вводе формулы (= …), как в Calc/Excel.
 */
import { formatCellRef, colLabel } from './formulaEngine.js';

const BEFORE_POINT = new Set(['=', '(', ';', ',', '+', '-', '*', '/', ':']);

/**
 * Можно ли со стрелки/клика вставить ссылку при caret в draft.
 * draft должен начинаться с '='.
 */
export function canPointInsert(draft, caret) {
  const s = String(draft || '');
  if (!s.startsWith('=')) return false;
  const pos = Math.max(0, Math.min(Number(caret) || 0, s.length));
  // внутри кавычек — не указываем
  let inStr = false;
  for (let i = 0; i < pos; i += 1) {
    if (s[i] === '"') {
      if (s[i + 1] === '"') {
        i += 1;
        continue;
      }
      inStr = !inStr;
    }
  }
  if (inStr) return false;

  // если caret внутри уже выделенного нами ref — можно двигать (caller знает pointing)
  let i = pos - 1;
  while (i >= 0 && s[i] === ' ') i -= 1;
  if (i < 0) return s === '=' || s.startsWith('=');
  const ch = s[i];
  if (BEFORE_POINT.has(ch)) return true;
  // caret сразу после буквенно-цифровой ссылки — тоже ок (замена текущей)
  if (/[A-Za-z0-9$]/.test(ch)) return true;
  return false;
}

/** Диапазон токена ссылки вокруг caret (или null). */
export function refTokenAround(draft, caret) {
  const s = String(draft || '');
  const pos = Math.max(0, Math.min(Number(caret) || 0, s.length));
  let start = pos;
  let end = pos;
  while (start > 0 && /[A-Za-z0-9$:]/.test(s[start - 1])) start -= 1;
  while (end < s.length && /[A-Za-z0-9$:]/.test(s[end])) end += 1;
  const token = s.slice(start, end);
  if (!/^[A-Za-z$]+\d+(:[A-Za-z$]+\d+)?$/.test(token) && !/^\$?[A-Za-z]+\$?\d+$/.test(token)) {
    return null;
  }
  return { start, end, token };
}

/**
 * Вставить или заменить ссылку в draft.
 * Если есть pointing.refStart/refEnd — заменить этот кусок.
 * Иначе: если caret на токене-ссылке — заменить его; иначе вставить в caret.
 */
export function applyPointedRef(draft, caret, row, col, pointing) {
  const s = String(draft || '');
  const ref = formatCellRef({ row, col });
  let start;
  let end;
  if (pointing && Number.isFinite(pointing.refStart) && Number.isFinite(pointing.refEnd)) {
    start = pointing.refStart;
    end = pointing.refEnd;
  } else {
    const tok = refTokenAround(s, caret);
    if (tok) {
      start = tok.start;
      end = tok.end;
    } else {
      start = Math.max(0, Math.min(Number(caret) || 0, s.length));
      end = start;
    }
  }
  const next = s.slice(0, start) + ref + s.slice(end);
  const nextCaret = start + ref.length;
  return {
    draft: next,
    caret: nextCaret,
    pointing: {
      refStart: start,
      refEnd: start + ref.length,
      row,
      col,
    },
  };
}

export function movePoint(row, col, dr, dc, rows, cols) {
  return {
    row: Math.max(0, Math.min(rows - 1, row + dr)),
    col: Math.max(0, Math.min(cols - 1, col + dc)),
  };
}

export { formatCellRef, colLabel };
